import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useSidebarNavStore = create(
    persist(
        set => ({
            collapsed: false,
            mobileOpen: false,

            toggleCollapse: () =>
                set(state => ({ collapsed: !state.collapsed })),
            setCollapsed: collapsed => set({ collapsed }),
            setMobileOpen: mobileOpen => set({ mobileOpen }),
        }),
        {
            name: 'sidebar-nav',
            partialize: state => ({ collapsed: state.collapsed }),
        }
    )
);
